import { Capacitor } from "@capacitor/core";

let hidden = false;

/**
 * Dismiss the native launch screen.
 *
 * iOS and Android can't show web content until the webview has booted, so
 * every app gets a native launch screen covering that gap — ours carries the
 * same leaf as ZuzuSplash without the wordmark, which is why the two read as
 * one screen. It has no timer of its own (see capacitor.config.ts): it stays
 * up until this runs, so there is never a frame of empty webview between the
 * two halves. ZuzuSplash calls this the moment its own leaf has painted, and
 * main.tsx keeps a backstop for the routes that never show a splash at all.
 *
 * Safe to call repeatedly, on any platform, at any time. The plugin is
 * imported lazily so the website never pays for it.
 */
export function hideNativeSplash(): void {
  if (hidden) return;
  hidden = true;
  try {
    if (!Capacitor.isNativePlatform()) return;
    void import("@capacitor/splash-screen")
      .then(({ SplashScreen }) => SplashScreen.hide())
      .catch(() => {});
  } catch {
    // Plugin missing or webview mid-teardown — launchShowDuration in
    // capacitor.config.ts still clears it.
  }
}

/** Test seam: forget that we've already hidden it. */
export function resetNativeSplashForTests(): void {
  hidden = false;
}

export default hideNativeSplash;
